var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48607 2 2 6.48607 2 12C2 17.5139 6.48607 22 12 22C17.5139 22 22 17.5139 22 12C22 6.48607 17.5139 2 12 2ZM12.6505 17.9332C12.1754 18.0124 11.23 18.2103 10.75 18.25C10.3436 18.2837 9.96019 18.0511 9.72644 17.7172C9.49208 17.3833 9.43593 16.956 9.57506 16.5727L11.4653 11.375H9.49998C9.4983 10.292 10.3107 9.49559 11.3497 9.18997C11.8456 9.04408 12.7694 8.84444 13.25 8.87503C13.5379 8.89335 14.0398 9.07399 14.2735 9.40788C14.5079 9.74174 14.564 10.169 14.4249 10.5523L12.5346 15.75H14.4994C14.4998 16.8318 13.7177 17.7554 12.6505 17.9332ZM13.25 8.25001C12.5596 8.25001 12 7.6903 12 7C12 6.30962 12.5596 5.74999 13.25 5.74999C13.9403 5.74999 14.5 6.30962 14.5 7C14.5 7.69034 13.9404 8.25001 13.25 8.25001Z",
    fill: "#F48000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutusIcon);
export default __webpack_public_path__ + "static/media/aboutus_icon.65ea4e0e3891dd369e1b214e55cd40f6.svg";
export { ForwardRef as ReactComponent };